module.exports = __webpack_public_path__ + "img/car_sendai04.a58460e0.jpg";